import {usePermissions} from "./usePermissions";

/** Keep in step with PdpAccess and the existing driver page grants. */
export function usePdpPermissions() {
  const permissions=usePermissions();
  const role=permissions.userProfile?.role?.name;
  const operator=["ROLE_CLIENT_ADMIN","ROLE_CLIENT_OPERATOR","ROLE_FEDERATION_ADMIN","ROLE_FEDERATION_OPERATOR","ROLE_TRANSPORTER_ADMIN"].includes(role || "");
  const legacyManage=((role==="ROLE_CLIENT_ADMIN" || role==="ROLE_FEDERATION_ADMIN") && permissions.canEditJob()) ||
    (role==="ROLE_TRANSPORTER_ADMIN" && permissions.can("CAN_VIEW_JOB"));
  const canManagePdp=operator && (permissions.canCrudDriver() || legacyManage);
  return {canManagePdp,canReadPdp:operator && (canManagePdp || permissions.can("CAN_VIEW_JOB"))};
}
